import ROLES from '../../roles'

export default {
  /**
   * @path http://localhost:8081/#/dashboard
   */
  CAN_NOT_VIEW_CHARTS: [ROLES.PB_FIELD_AGENT, ROLES.LEASING_STAFF], // users that can NOT view charts
  CAN_NOT_VIEW_GUEST_CHART: [ROLES.PB_FIELD_AGENT], // users that can NOT view charts
  CAN_NOT_VIEW_TOP_EARNINGS: [ROLES.LEASING_STAFF], // users that can NOT view top earning communities
  CAN_ONLY_VIEW_SEARCH: [ROLES.TOW_DRIVER] // users that can only see the search side of the dashboard
}



// WEBPACK FOOTER //
// ./src/roles/rules/dashboard/index.js